"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.todos.completed': '已完成',
    'tutorial.todos.pending': '待处理',
    'tutorial.todos.markCompleted': '标记为已完成',
    'tutorial.todos.markPending': '标记为待处理',
    'tutorial.todos.statusDone': '已完成',
    'tutorial.todos.statusUndone': '未完成',
    'tutorial.todos.changeComment.1': '你已将任务“{name}”的状态更改为：{status}。',
    'tutorial.todos.changeComment.2': '任务“{name}”——{status}。已记录。',
    'tutorial.todos.changeComment.3': '我已记录这一变更：任务“{name}”现在为{status}。',
    'tutorial.todos.changeComment.4': '已保存！任务“{name}”已标记为{status}。',
    'tutorial.audio.stop': '停止',
    'tutorial.audio.pause': '暂停',
    'tutorial.audio.play': '播放',
    'tutorial.audio.volume': '音量',
    'tutorial.audio.writingSpeed': '书写速度',
    'tutorial.audio.writingSpeed.normal': '正常',
    'tutorial.audio.writingSpeed.fast': '快',
    'tutorial.audio.writingSpeed.veryFast': '非常快',
};
